import React from 'react';
import { useHistory } from 'react-router-dom';
import { paths } from 'routes/paths';
import IntegrationsIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/IntegrationsIcon';
import InvoiceIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/InvoiceIcon';
import PlansIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/PlansIcon';
import RecommendationIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/RecommendationIcon';
import WorkOrdersIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/WorkOrdersIcon';
import {
  IntegrationSourceType,
  RecordSource,
  RecordSourceType
} from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';

interface RecordSourceButtonValues {
  icon: React.ReactNode;
  isClickable: boolean;
  tooltipTitle?: string;
  recordSourceName?: string;
  onClick?: () => void;
}
const useRecordValues = (
  recordSource: RecordSource
): RecordSourceButtonValues => {
  const history = useHistory();

  const getResourceNameFromIntegration = () => {
    let suffix = '';
    switch (recordSource.integrationSourceType) {
      case IntegrationSourceType.FARMOBILE:
        suffix = 'Farmobile';
        break;
      case IntegrationSourceType.TRIMBLE_AGRICULTURE:
        suffix = 'Trimble';
        break;
      case IntegrationSourceType.AGFINITI:
        suffix = 'AgFinity';
        break;
      case IntegrationSourceType.CNHI:
        suffix = 'CNH';
        break;
      case IntegrationSourceType.JOHN_DEERE:
        suffix = 'John Deere';
        break;
      case IntegrationSourceType.OTHER:
        suffix = 'File Upload';
        break;
      default:
        suffix = 'Connect';
        break;
    }

    return `Imported from ${suffix}`;
  };
  switch (recordSource.recordSourceType) {
    case RecordSourceType.WORK_ORDER:
      return {
        icon: <WorkOrdersIcon />,
        isClickable: true,
        tooltipTitle: 'Work Order',
        onClick: () => {
          const params = new URLSearchParams();
          if (recordSource.recordSourceName) {
            params.set('search', recordSource.recordSourceName);
          }
          history.push({
            pathname: paths.workOrders,
            search: params.toString() ? `?${params.toString()}` : '',
            state: {
              operationId: recordSource.recordSourceId
            }
          });
        }
      };
    case RecordSourceType.RECOMMENDATION:
      return {
        icon: <RecommendationIcon />,
        isClickable: true,
        tooltipTitle: 'Recommendation',
        onClick: () => {
          history.push(
            `${paths.recommendations}/${recordSource.recordSourceId}/view`
          );
        }
      };
    case RecordSourceType.INVOICE:
      return {
        icon: <InvoiceIcon />,
        isClickable: true,
        tooltipTitle: 'Invoice',
        onClick: () => {
          const params = new URLSearchParams();
          if (recordSource.recordSourceName) {
            params.set('search', recordSource.recordSourceName);
          }
          history.push({
            pathname: paths.invoices,
            search: params.toString() ? `?${params.toString()}` : '',
            state: {
              operationId: recordSource.recordSourceId
            }
          });
        }
      };
    case RecordSourceType.PLANS:
      return {
        icon: <PlansIcon />,
        isClickable: true,
        tooltipTitle: 'Plan',
        onClick: () => {
          const params = new URLSearchParams();
          if (recordSource.recordSourceName) {
            params.set('search', recordSource.recordSourceName);
          }
          params.set('planId', recordSource.recordSourceId);
          history.push({
            pathname: `${paths.plans}/${recordSource.recordSourceId}/view`,
            search: params.toString() ? `?${params.toString()}` : ''
          });
        }
      };
    default:
      return {
        icon: <IntegrationsIcon />,
        isClickable: false,
        recordSourceName: getResourceNameFromIntegration()
      };
  }
};

export default useRecordValues;
